export function SetSelectedMachineIdInLocalStorage(machineId: MachineId) {
  localStorage.setItem("selectedSortingMachineId", machineId.toString());
}

export function GetSelectedMachineIdFromLocalStorage(): string | null {
  return localStorage.getItem("selectedSortingMachineId");
}
